import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import moment from "moment";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";

import { useMainContent } from "../OurClients.hooks";
import { fields } from "../constants";

export const MainContent = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const { data: editData, error, isLoading: drilldownLoading, isError, refetch: refetchEditData } = useMainContent();
  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (!query.get("id")) {
      refetchEditData();
    }
  }, []);

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
  }, [query.get("id")]);

  const OurClientsMainContentConfig: FormConfig = {
    initialValues: {
      id: dataById ? dataById.payload.id : editData ? editData?.id : "",

      field_our_client_text: dataById
        ? decodeHTML(dataById.payload.field_our_client_text)
        : editData
          ? decodeHTML(editData?.field_our_client_text)
          : "",

      field_our_client_text_ms: dataById
        ? decodeHTML(dataById.payload.field_our_client_text_ms)
        : editData
          ? decodeHTML(editData?.field_our_client_text_ms)
          : "",

      field_our_client_text_zhans: dataById
        ? decodeHTML(dataById.payload.field_our_client_text_zhans)
        : editData
          ? decodeHTML(editData?.field_our_client_text_zhans)
          : "",

      field_local_en: dataById
        ? decodeHTML(dataById.payload.field_local_en)
        : editData
          ? decodeHTML(editData?.field_local_en)
          : "",

      field_local_ms: dataById
        ? decodeHTML(dataById.payload.field_local_ms)
        : editData
          ? decodeHTML(editData?.field_local_ms)
          : "",

      field_local_zh: dataById
        ? decodeHTML(dataById.payload.field_local_zh)
        : editData
          ? decodeHTML(editData?.field_local_zh)
          : "",

      field_international_en: dataById
        ? decodeHTML(dataById.payload.field_international_en)
        : editData
          ? decodeHTML(editData?.field_international_en)
          : "",

      field_international_ms: dataById
        ? decodeHTML(dataById.payload.field_international_ms)
        : editData
          ? decodeHTML(editData?.field_international_ms)
          : "",

      field_international_zh: dataById
        ? decodeHTML(dataById.payload.field_international_zh)
        : editData
          ? decodeHTML(editData?.field_international_zh)
          : "",

      published: dataById ? dataById.payload.published : editData ? editData?.published : false,
    },

    fields: fields.ourClientsMainContent,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["appStoreImage", "playStoreImage"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let dateKeys: any = ["date"];
    for (const key of dateKeys) {
      if (data[key]) {
        data[key] = moment(data[key]).format("DD MMM YYYY");
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Malaysia Airport Academy",
      subModule: "ourClients_ourClientsMainContent",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Malaysia Airport Academy_Our Clients",
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
     
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
      isLoading={isLoadingData || drilldownLoading}
      config={OurClientsMainContentConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${corporateHost}/api/client-header/${editData?.id || dataById?.payload?.id || ""}`,
          "UPDATE",
          "PATCH",
          buttonValue == "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
      defaultReviewNotes="Kindly review this Malaysia Airports Academy"
    />
  );
};
